import { useEffect, useState } from 'react';

export function useAppHeight() {
  const [appHeight, setAppHeight] = useState<string>('100dvh');
  const [safeArea, setSafeArea] = useState({
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
  });

  useEffect(() => {
    const isIOS = /iP(ad|hone|od)/.test(navigator.userAgent);
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

    function updateHeight() {
      if (isIOS && isSafari) {
        setAppHeight(`${window.innerHeight}px`);
        const style = getComputedStyle(document.documentElement);
        setSafeArea({
          top: parseInt(
            style.getPropertyValue('env(safe-area-inset-top)') || '0'
          ),
          bottom: parseInt(
            style.getPropertyValue('env(safe-area-inset-bottom)') || '0'
          ),
          left: parseInt(
            style.getPropertyValue('env(safe-area-inset-left)') || '0'
          ),
          right: parseInt(
            style.getPropertyValue('env(safe-area-inset-right)') || '0'
          ),
        });
      } else {
        setAppHeight('100dvh');
        setSafeArea({ top: 0, bottom: 0, left: 0, right: 0 });
      }
    }

    updateHeight();
    window.addEventListener('resize', updateHeight);
    window.addEventListener('orientationchange', updateHeight);

    return () => {
      window.removeEventListener('resize', updateHeight);
      window.removeEventListener('orientationchange', updateHeight);
    };
  }, []);

  return { appHeight, safeArea };
}
